
/* Metafield label rotator – announcement-bar style */
(function () {

  function initLabelRotators() {
    document
      .querySelectorAll('.product-card__metafield-labels:not([data-label-count="1"])')
      .forEach(function (container) {

        var track = container.querySelector('.product-card__metafield-labels__track');
        if (!track) return;

        // Already initialized
        if (track.dataset.rotatorActive === 'true') return;

        var labels = track.querySelectorAll('.product-card__metafield-label');
        var count = parseInt(container.dataset.labelCount, 10);

        if (!labels.length || count <= 1) return;

        track.dataset.rotatorActive = 'true';

        var current = 0;
        var gap = 10;

        function rotate() {
          // Don't rotate while hidden (tabs/sliders)
          if (container.offsetParent === null) return;

          var labelHeight = labels[0].offsetHeight + gap;

          current++;

          track.style.transition = 'transform 0.4s ease-in-out';
          track.style.transform =
            'translateY(-' + current * labelHeight + 'px)';

          if (current >= count) {
            setTimeout(function () {
              track.style.transition = 'none';
              track.style.transform = 'translateY(0)';
              current = 0;
            }, 420);
          }
        }

        // Save interval ID to prevent duplicates
        track.rotatorInterval = setInterval(rotate, 2000);
      });
  }

  function reInit() {
    initLabelRotators();
  }

  // Initial load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', reInit);
  } else {
    reInit();
  }

  // Observe dynamically added content (tabs/sliders/AJAX)
  var observer = new MutationObserver(function () {
    reInit();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

})();